import request from '@/services/interceptor.js'

export const get_verifica_accesso = (companyCode) => {
    return request({
        url: '/registrosintesiPEFC/accesso?companyCode=' + companyCode,
        method: 'get',
        loadingBar: false
    })
}

//#region Tabelle di anagrafica


export const get_gruppi_prodotto = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/gruppi-prodotto' + par,
        method: 'get',
        loadingBar: true
    })
}
export const post_gruppo_prodotto = (data) => {
    return request({
        url: '/registrosintesiPEFC/gruppi-prodotto',
        method: 'post',
        data,
        loadingBar: true
    })
}
export const del_gruppo_prodotto = (data) => {
    return request({
        url: '/registrosintesiPEFC/gruppi-prodotto',
        method: 'delete',
        data,
        loadingBar: true
    })
}

export const del_gruppi_prodotto_bulk = (data) => {
    return request({
        url: '/registrosintesiPEFC/gruppi-prodotto/bulk',
        method: 'delete',
        data,
        loadingBar: true
    })
}
export const reset_gruppi_prodotto = (par) => {
    return request({
        url: '/registrosintesiPEFC/gruppi-prodotto/default' + par,
        method: 'get',
        loadingBar: true
    })
}


export const get_fattori_conversione_uscita = () => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione-uscita',
        method: 'get',
        loadingBar: true
    })
}

export const post_fattore_conversione_uscita = (data) => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione-uscita',
        method: 'post',
        data,
        loadingBar: true
    })
}
export const del_fattore_conversione_uscita = (data) => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione-uscita',
        method: 'delete',
        data,
        loadingBar: true
    })
}


export const get_fattori_conversione = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione' + par,
        method: 'get',
        loadingBar: true
    })
}

export const post_fattore_conversione = (data) => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione',
        method: 'post',
        data,
        loadingBar: true
    })
}
export const del_fattore_conversione = (data) => {
    return request({
        url: '/registrosintesiPEFC/fattori-conversione',
        method: 'delete',
        data,
        loadingBar: true
    })
}

export const get_um = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/um' + par,
        method: 'get',
        loadingBar: true
    })
}

export const get_essenze = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/essenze' + par,
        method: 'get',
        loadingBar: true
    })
}
//#endregion

//#region Commesse FSC in uscita
export const get_log_commesse = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/log-commesse' + par,
        method: 'get',
        loadingBar: true
    })
}

export const set_commessa = (data) => {
    return request({
        url: '/registrosintesiPEFC/log-commesse',
        method: 'post',
        data: data,
        loadingBar: true
    })
}

export const del_commessa = (data) => {
    return request({
        url: '/registrosintesiPEFC/log-commesse',
        method: 'delete',
        data: data,
        loadingBar: true
    })
}

//#endregion

//#region Materie prime in ingresso

export const get_materiali = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/materiali' + par,
        method: 'get',
        loadingBar: true
    })
}

export const set_materiale = (data) => {
    return request({
        url: '/registrosintesiPEFC/materiale',
        method: 'post',
        data: data,
        loadingBar: true
    })
}
export const del_materiale = (data) => {
    return request({
        url: '/registrosintesiPEFC/materiale',
        method: 'delete',
        data: data,
        loadingBar: true
    })
}
//#endregion

export const get_materiali_consumo = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/materiali-consumo' + par,
        method: 'get',
        loadingBar: true
    })
}

export const get_documenti_commesse = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/documenti-commesse' + par,
        method: 'get',
        loadingBar: true
    })
}


export const salva_declassamento = (data) => {
    return request({
        url: '/registrosintesiPEFC/declassamento',
        method: 'post',
        data: data,
        loadingBar: true
    })
}

export const get_storico_declassamento = (par = "") => {
    return request({
        url: '/registrosintesiPEFC/declassamento/storico' + par,
        method: 'get',
        loadingBar: true
    })
}

export const salva_storico_declassamento = (data, method) => {
    return request({
        url: '/registrosintesiPEFC/declassamento/storico',
        method: method,
        data: data,
        loadingBar: true
    })
}

export const esporta_dati = (data) => {
    return request({
        url: '/registrosintesiPEFC/esporta-dati',
        method: 'post',
        data: data,
        loadingBar: true
    })
}